import React from "react";

import { Main } from "./Components"

import "./styles.scss";

const PCSGenerator = () => {
    

    return (
        <div className="bpl-container">
            <Main />
        </div>
    );
};

export default React.forwardRef(PCSGenerator);
